import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    APP_NAME,
    COIN_NAME,
    PAYMENT_THRESHOLD,
    HAS_INSTANT_DISCOUNT,
    APPLICATION_ID,
    USE_PARITY
} from '../constants';

import { convertHtmlToReactDomWithParams } from '../utils/htmlUtils';

import LocalizedNavLink from './router/LocalizedNavLink';

import { StepsContainer } from './StepsComponentStyle';
import { getI18nByApp } from '../services/i18n/selector';

class StepsComponent extends React.Component {
    getRefundWording = () => {
        const { i18n } = this.props;

        if (getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.REFUND')[APPLICATION_ID]) {
            return getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.REFUND')[APPLICATION_ID];
        } else {
            return getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.REFUND').DEFAULT;
        }
    };

    getLabelText = () => {
        const { i18n } = this.props;
        switch (true) {
            case USE_PARITY:
                return convertHtmlToReactDomWithParams(
                    getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.EBON.STEP2_PARITY_DISCOUNT'),
                    COIN_NAME,
                    APP_NAME
                );
            case HAS_INSTANT_DISCOUNT:
                return convertHtmlToReactDomWithParams(
                    getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.EBON.STEP2_INSTANT_DISCOUNT')
                );
            default:
                return convertHtmlToReactDomWithParams(
                    getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.EBON.STEP2_CASHBACK_DISCOUNT'),
                    APP_NAME,
                    this.getRefundWording()
                );
        }
    };

    getSteps = () => {
        const { isOffline, isEbon, i18n } = this.props;

        if (isOffline) {
            return (
                <React.Fragment>
                    <div className="cmt-ca-marche-bloc">
                        <div className="digit-icon">
                            <span>1</span>
                        </div>
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.OFFLINE.STEP1'),
                                    APP_NAME
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <div className="digit-icon">
                            <span>2</span>
                        </div>
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.OFFLINE.STEP2_1')
                                )}
                                <LocalizedNavLink
                                    to="/envoi-ticket"
                                    title={getI18nByApp(
                                        i18n,
                                        'feature.aide.HOW_IT_WORKS.OFFLINE.STEP2_2'
                                    )}>
                                    {getI18nByApp(
                                        i18n,
                                        'feature.aide.HOW_IT_WORKS.OFFLINE.STEP2_2'
                                    )}
                                </LocalizedNavLink>
                                {getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.OFFLINE.STEP1_3')}
                            </p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <div className="digit-icon">
                            <span>3</span>
                        </div>
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.OFFLINE.STEP3'),
                                    PAYMENT_THRESHOLD
                                )}
                            </p>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else if (isEbon) {
            return (
                <React.Fragment>
                    <div className="cmt-ca-marche-bloc">
                        <div className="digit-icon">
                            <span>1</span>
                        </div>
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.EBON.STEP1')
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <div className="digit-icon">
                            <span>2</span>
                        </div>
                        <div className="texte">
                            <p>{this.getLabelText()}</p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <div className="digit-icon">
                            <span>3</span>
                        </div>
                        <div className="texte">
                            <p>
                                {getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.EBON')[
                                    APPLICATION_ID
                                ]
                                    ? convertHtmlToReactDomWithParams(
                                          getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.EBON')[
                                              APPLICATION_ID
                                          ].STEP3
                                      )
                                    : convertHtmlToReactDomWithParams(
                                          getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.EBON.STEP3')
                                      )}
                            </p>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="cmt-ca-marche-bloc">
                        <div className="digit-icon">
                            <span>1</span>
                        </div>
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.ONLINE.STEP1'),
                                    APP_NAME
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <div className="digit-icon">
                            <span>2</span>
                        </div>
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.ONLINE.STEP2')
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <div className="digit-icon">
                            <span>3</span>
                        </div>
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.ONLINE.STEP3'),
                                    PAYMENT_THRESHOLD
                                )}
                            </p>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    };

    render() {
        return (
            <StepsContainer>
                <div className="wrapper">{this.getSteps()}</div>
            </StepsContainer>
        );
    }
}

StepsComponent.propTypes = {
    isOffline: PropTypes.bool
};

const mapStoreToProps = state => ({
    i18n: state.i18n
});

export default connect(mapStoreToProps)(StepsComponent);



// WEBPACK FOOTER //
// ./src/components/StepsComponent.js